"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetOffering = exports.getPriceData = exports.evaluateStepValue = exports.createPaymentOptions = exports.calculateUpsellPayment = void 0;
var _constants = require("./constants");
var _utils = require("./utils");
var calculateUpsellPayment = function calculateUpsellPayment(totalCost, selectedUpfrontValue, selectedTermValue) {
  var monthlyPrice = (totalCost - selectedUpfrontValue) / selectedTermValue;
  return {
    upfront: selectedUpfrontValue,
    monthlyPrice: monthlyPrice,
    monthlyPeriod: selectedTermValue
  };
};
exports.calculateUpsellPayment = calculateUpsellPayment;
var createPaymentOptions = function createPaymentOptions(monthlyPrice, monthlyPeriod, monthlyUnit, upfront) {
  return [{
    label: {
      type: _constants.PRICE_TYPES.RECURRING,
      value: monthlyPrice,
      term: monthlyPeriod
    },
    price: {
      value: monthlyPrice,
      unit: monthlyUnit
    }
  }, {
    label: {
      type: _constants.PRICE_TYPES.UP_FRONT,
      value: upfront
    },
    price: {
      value: upfront,
      unit: ''
    }
  }];
};
exports.createPaymentOptions = createPaymentOptions;
var resetOffering = function resetOffering(item) {
  var offering = (0, _utils.clone)(item);
  if (offering.variants) offering.selectedVariant = offering.variants.variants[0];
  offering.selectedPrice = null;
  offering.paymentOptions = createPaymentOptions(offering.recurringPriceValue, offering.recurringPriceTerm, '', offering.upfrontPriceValue);
  return offering;
};
exports.resetOffering = resetOffering;
var evaluateStepValue = function evaluateStepValue(_ref) {
  var min = _ref.min,
    max = _ref.max,
    stepValue = _ref.stepValue;
  var isStepValueApplicable = (max - min) % stepValue === 0;
  return isStepValueApplicable ? stepValue : 1;
};
exports.evaluateStepValue = evaluateStepValue;
var getPriceData = function getPriceData(offering) {
  return {
    value: offering.productOfferingPrice[0].price.value,
    unit: offering.productOfferingPrice[0].price.unit,
    durationAmount: offering.productOfferingPrice[0].productOfferingTerm[0].duration.amount,
    durationUnit: offering.productOfferingPrice[0].productOfferingTerm[0].duration.units
  };
};
exports.getPriceData = getPriceData;